<template>
  <div>
    <div v-if="widthMax > 768" class="dashboard is-hidden-mobile">
      <div class="columns">
        <aside
          class="menu is-1 disablePrint"
          :class="[{'is-invisible':modalActive},[getRule === 'startup' ? 'is-background-primary' : 'is-background-secondary']]"
        >
          <p class="link is-info">
            <img
              alt="InteGreat logo"
              src="../assets/logo-portrait.svg"
              class="is-padding-m-x is-padding-y"
            />
          </p>
          <!-- <a v-else-if="getRule == 'staff'" class="link is-info" href="/startup-list">
                  <img
                      alt="InteGreat logo"
                      src="../assets/logo-portrait.svg"
                      class="is-padding-m-x is-padding-y"
                  >
              </a>
              <a v-else class="link is-info" href="/dashboard">
                  <img
                      alt="InteGreat logo"
                      src="../assets/logo-portrait.svg"
                      class="is-padding-m-x is-padding-y"
                  >
          </a>-->
          <router-link
            v-if="getRule !== 'startup' || user.statusActive !== 0"
            to="/dashboard"
            class="link is-info"
            @mouseover.native="menuDashboard = '-active'"
            @mouseout.native="menuDashboard = ''"
          >
            <img
              alt="Dashboard"
              v-if="active == '/dashboard'"
              :src="require(`@/assets/menu-dashboard-active.svg`)"
              id="menu-dashboard"
              class="is-padding-x"
            />
            <img
              alt="Dashboard"
              v-else
              :src="require(`@/assets/menu-dashboard${menuDashboard}.svg`)"
              id="menu-dashboard"
              class="is-padding-x"
            />
            <p class="has-text-centered">Dashboard</p>
          </router-link>
          <router-link
            v-if="getRule === 'admin' || getRule === 'staff'"
            to="/doc"
            class="link is-info"
            @mouseover.native="menuDoc = '-active'"
            @mouseout.native="menuDoc = ''"
          >
            <img
              alt="Document management"
              v-if="active == '/doc'"
              :src="require(`@/assets/menu-doc-active.svg`)"
              class="is-padding-x"
            />
            <img
              alt="Document management"
              v-else
              :src="require(`@/assets/menu-doc${menuDoc}.svg`)"
              class="is-padding-x"
            />
            <p class="has-text-centered">Department list</p>
          </router-link>
          <router-link
            v-if="getRule === 'admin' || getRule === 'staff'"
            to="/doc"
            class="link is-info"
            @mouseover.native="menuDoc = '-active'"
            @mouseout.native="menuDoc = ''"
          >
            <img
              alt="Document management"
              v-if="active == '/doc'"
              :src="require(`@/assets/menu-doc-active.svg`)"
              class="is-padding-x"
            />
            <img
              alt="Document management"
              v-else
              :src="require(`@/assets/menu-doc${menuDoc}.svg`)"
              class="is-padding-x"
            />
            <p class="has-text-centered">Documents</p>
          </router-link>
          <router-link
            to="/report-board-list"
            class="link is-info"
            @mouseover.native="menuForm = '-active'"
            @mouseout.native="menuForm = ''"
          >
            <img
              alt="Form"
              v-if="active == '/form'"
              :src="require(`@/assets/form-active.svg`)"
              class="is-padding-x"
            />
            <img
              alt="Form"
              v-else
              :src="require(`@/assets/form${menuForm}.svg`)"
              class="is-padding-x"
            />
            <p class="has-text-centered">Smart report</p>
          </router-link>
          <div
            @click="logout()"
            class="link is-info is-pointer"
            @mouseover="menuSignout = '-active'"
            @mouseout="menuSignout = ''"
          >
            <img
              alt="Logout"
              :src="require(`@/assets/menu-signout${menuSignout}.svg`)"
              class="is-padding-x"
            />
            <p>Sign out</p>
          </div>
        </aside>
        <div class="has-background-light has-text-black column main-d is-padding">
          <div class="level disablePrint">
            <div class="level-left">
              <div class="level-item">
                <div class="media is-align-center">
                  <div class="media-left">
                    <figure class="image box-circle-m">
                      <img
                        class="is-rounded"
                        v-if="typeof user.profilePic !== 'undefined' && user.profilePic !== null && user.profilePic !== ''"
                        :src="imgUrl+getUserImage()"
                      />
                      <img
                        class="is-rounded"
                        v-else
                        src="https://bulma.io/images/placeholders/128x128.png"
                        alt="Placeholder image"
                      />
                    </figure>
                  </div>
                  <div
                    class="is-justify-start is-align-start is-flex-medium is-flex-column width-max"
                  >
                    <div class="is-justify-start is-align-center is-flex width-max">
                      <p class="is-size-6 textWelcome has-text-grey has-text-weight-normal th">
                        ชื่อองค์กร:
                        <span
                          class="has-text-black th"
                        >{{getTiltleScience(user.scienceParkId)}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <div class="column-action is-marginless is-justify-center dp-menu-action">
                  <b-dropdown position="is-bottom-left">
                    <button class="button dp-btn-noBg is-margin-right-ml" slot="trigger">
                      <template>
                        <b-icon
                          pack="fas"
                          icon="sync-alt"
                          size="is-large"
                          custom-class="fa-question-circle"
                          class="has-text-grey-light"
                        ></b-icon>
                      </template>
                    </button>

                    <b-dropdown-item
                      @click="isUserDetailModalActive = true"
                      has-link
                      class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                    >
                      <router-link to="/faq" class="dp-link">FAQs</router-link>
                    </b-dropdown-item>
                    <!-- <b-dropdown-item
                      has-link
                      @click="isDeleteStaff = true"
                      v-if="getRule != 'specialadmin'"
                      class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                    >
                      <a
                        target="_blank"
                        v-if="getRule == 'admin'"
                        class="dp-link"
                        href="/manual/integreatAdminManual.pdf"
                      >Manual</a>
                      <a
                        target="_blank"
                        v-if="getRule == 'staff'"
                        class="dp-link"
                        href="/manual/integreatStaffManual.pdf"
                      >Manual</a>
                      <a target="_blank" v-if="getRule == 'startup'" class="dp-link" href="#">Manual</a>
                    </b-dropdown-item>-->
                    <b-dropdown-item
                      @click="isContact = true"
                      class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                      has-link
                    >
                      <a class="dp-link">Contact</a>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="content has-text-left">
            <div
              v-if="typeof user.userStatus === 'undefined' || user.userStatus === 0"
              class="pd-10 has-text-centered active-email-boder"
            >
              <p class="th has-text-danger-status">
                คุณยังไม่ได้ทำการยืนยันอีเมล กรุณายืนยันอีเมล หรือทำการ
                <a @click="everEmailActive()">ส่งอีเมลอีกครั้ง</a> เพื่อรับการแจ้งเตือนทางอีเมล
              </p>
            </div>
            <slot></slot>
          </div>
          <!-- <div v-if="batch.isSpa===true" class="disablePrint">
            <hr>
            <footer class="level footer-db">
         
              <div class="level-left">
                <div class="level-item">
                  <p class="subtitle is-6">
                    <strong>inteGreat</strong> &copy;
                    <a href="https://lffintech.co.th">2019</a>.
                  </p>
                </div>
                 <div class="level-item">
                <div class="field has-addons">
                  <p class="control">
                    <input class="input" type="text" placeholder="Find things...">
                  </p>
                  <p class="control">
                    <button class="button">Search</button>
                  </p>
                </div>
                </div>
              </div>

             
              <div class="level-right partner-logo">
                <p class="level-item">
                  <img alt="SPA logo" src="../assets/logo-most-mini.svg" width="50">
                </p>
                <p class="level-item">
                  <img alt="SPA logo" src="../assets/logo-spa-mini.svg" width="80">
                </p>
              </div>
            </footer>
          </div>-->
        </div>
      </div>
    </div>

    <div v-else class="dashboard is-hidden-tablet">
      <div class="columns">
        <div class="has-background-light has-text-black is-paddingless">
          <div class="nav-mobile is-flex is-align-center">
            <div class="is-flex flex-1 is-align-center">
              <p class="link is-info">
                <a @click="(navActive)?navActive=false:navActive=true">
                  <i class="fas fa-lg fa-bars has-text-white"></i>
                </a>
                <img alt="InteGreat logo" src="../assets/logo-mobile.png" class="pd-x-10" />
              </p>
            </div>
            <div class="is-flex flex-1 is-justify-end is-align-center">
              <figure class="image box-circle-mobile">
                <img class="is-rounded" v-if="imgUrl+user.profilePic" :src="imgUrl+getUserImage()" />
                <img
                  class="is-rounded"
                  v-else
                  src="https://bulma.io/images/placeholders/128x128.png"
                  alt="Placeholder image"
                />
              </figure>
              <b-dropdown position="is-bottom-left">
                <button class="button dp-btn-noBg" slot="trigger">
                  <p class="is-size-7 pd-x-10 has-text-white th is-flex is-align-center">
                    <span class="mg-r-5">{{getUserDetailName() | snippetMobile}}</span>
                    <i class="fas fa-caret-down"></i>
                  </p>
                </button>
                <b-dropdown-item @click="isUserTitle = true">
                  <div class="media">
                    <b-icon class="media-left" pack="fas" icon="align-justify"></b-icon>
                    <div class="media-content th">
                      <h3>รายละเอียดโครงการ</h3>
                    </div>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="isOpenModalProfileMobile = true">
                  <div class="media">
                    <b-icon class="media-left" pack="fas" icon="user"></b-icon>
                    <div class="media-content th">
                      <h3>โปรไฟล์</h3>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="content has-text-left wrapper m-h-100-vh">
            <aside
              id="slide"
              class="menu is-background-primary is-1"
              :class="{'slide-active':navActive}"
            >
              <div class="mg-y-15">
                <router-link
                  v-if="getRule !== 'startup' || user.statusActive !== 0"
                  to="/dashboard"
                  class="link is-info"
                  @mouseover.native="menuDashboard = '-active'"
                  @mouseout.native="menuDashboard = ''"
                >
                  <img
                    alt="Dashboard"
                    v-if="active == '/dashboard'"
                    :src="require(`@/assets/menu-dashboard-active.svg`)"
                    id="menu-dashboard"
                    class="is-padding-x"
                  />
                  <img
                    alt="Dashboard"
                    v-else
                    :src="require(`@/assets/menu-dashboard${menuDashboard}.svg`)"
                    id="menu-dashboard"
                    class="is-padding-x"
                  />
                  <p class="has-text-centered">Dashboard</p>
                </router-link>
                <router-link
                  v-if="getRule === 'admin' || getRule === 'staff'"
                  to="/doc"
                  class="link is-info"
                  @mouseover.native="menuDoc = '-active'"
                  @mouseout.native="menuDoc = ''"
                >
                  <img
                    alt="Document management"
                    v-if="active == '/doc'"
                    :src="require(`@/assets/menu-doc-active.svg`)"
                    class="is-padding-x"
                  />
                  <img
                    alt="Document management"
                    v-else
                    :src="require(`@/assets/menu-doc${menuDoc}.svg`)"
                    class="is-padding-x"
                  />
                  <p class="has-text-centered">Department list</p>
                </router-link>
                <router-link
                  v-if="getRule === 'admin' || getRule === 'staff'"
                  to="/doc"
                  class="link is-info"
                  @mouseover.native="menuDoc = '-active'"
                  @mouseout.native="menuDoc = ''"
                >
                  <img
                    alt="Document management"
                    v-if="active == '/doc'"
                    :src="require(`@/assets/menu-doc-active.svg`)"
                    class="is-padding-x"
                  />
                  <img
                    alt="Document management"
                    v-else
                    :src="require(`@/assets/menu-doc${menuDoc}.svg`)"
                    class="is-padding-x"
                  />
                  <p class="has-text-centered">Document</p>
                </router-link>
                <router-link
                  to="/form"
                  class="link is-info"
                  @mouseover.native="menuForm = '-active'"
                  @mouseout.native="menuForm = ''"
                >
                  <img
                    alt="Form"
                    v-if="active == '/form'"
                    :src="require(`@/assets/form-active.svg`)"
                    class="is-padding-x"
                  />
                  <img
                    alt="Form"
                    v-else
                    :src="require(`@/assets/form${menuForm}.svg`)"
                    class="is-padding-x"
                  />
                  <p class="has-text-centered">Smart report</p>
                </router-link>
                <div
                  @click="logout()"
                  class="link is-info is-pointer"
                  @mouseover="menuSignout = '-active'"
                  @mouseout="menuSignout = ''"
                >
                  <img
                    alt="Logout"
                    :src="require(`@/assets/menu-signout${menuSignout}.svg`)"
                    class="is-padding-x"
                  />
                  <p class="has-text-centered">Sign out</p>
                </div>
              </div>
            </aside>
            <div :class="{'pd-5':pageNavActivity === ''}">
              <div
                v-if="typeof user.userStatus === 'undefined' || user.userStatus === 0"
                class="pd-10 has-text-centered active-email-boder"
              >
                <p class="th has-text-danger-status">
                  คุณยังไม่ได้ทำการยืนยันอีเมล กรุณายืนยันอีเมล หรือทำการ
                  <a @click="everEmailActive()">ส่งอีเมลอีกครั้ง</a> เพื่อรับการแจ้งเตือนทางอีเมล
                </p>
              </div>
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isOpenModalProfile" :width="1450" class="modal-min-width">
      <profile v-if="getRule =='startup'" @actionModalChangEmail="actionModalChangEmail" />

      <profileStaff v-if="getRule =='staff'" @actionModalChangEmail="actionModalChangEmail" />

      <profileAdmin v-if="getRule =='admin'" @actionModalChangEmail="actionModalChangEmail" />
    </b-modal>

    <b-modal :active.sync="isUserTitle" :width="640" scroll="keep">
      <div class="modal-card">
        <div class="modal-card-body">
          <div class="columns is-mobile">
            <div class="column" align="center">
              <div class="column-action is-marginless is-justify-end dp-menu-action">
                <b-dropdown position="is-bottom-left">
                  <button class="button dp-btn-noBg is-margin-right-ml" slot="trigger">
                    <template>
                      <b-icon
                        pack="fas"
                        icon="sync-alt"
                        size="is-large"
                        custom-class="fa-question-circle"
                        class="has-text-grey-light"
                      ></b-icon>
                    </template>
                  </button>

                  <b-dropdown-item
                    @click="isUserDetailModalActive =true"
                    class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                  >
                    <router-link to="/faq" class="dp-link">FAQs</router-link>
                  </b-dropdown-item>
                  <!-- <b-dropdown-item
                    @click="isDeleteStaff = true"
                    v-if="getRule != 'specialadmin'"
                    class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                  >
                    <a
                      target="_blank"
                      v-if="getRule == 'admin'"
                      class="dp-link"
                      href="/manual/integreatAdminManual.pdf"
                    >Manual</a>
                    <a
                      target="_blank"
                      v-if="getRule == 'staff'"
                      class="dp-link"
                      href="/manual/integreatStaffManual.pdf"
                    >Manual</a>
                    <a target="_blank" v-if="getRule == 'startup'" class="dp-link" href="#">Manual</a>
                  </b-dropdown-item>-->
                  <b-dropdown-item
                    @click="isContact = true"
                    class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
                    has-link
                  >
                    <a class="dp-link">Contact</a>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <figure class="image is-128x128">
                <img class="is-rounded" v-if="imgUrl+user.profilePic" :src="imgUrl+getUserImage()" />
                <img
                  class="is-rounded"
                  v-else
                  src="https://bulma.io/images/placeholders/128x128.png"
                  alt="Placeholder image"
                />
              </figure>
              <p class="has-text-grey-dark">
                <span class="is-size-5 has-text-weight-normal">Welcome!</span>
                <!-- <span class="th pd-l-10 is-size-6 fw-100">{{getUserDetailName()}}</span> -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isContact" :width="640">
      <div class="modal-card">
        <div class="modal-card-body">
          <div class="columns is-mobile">
            <div class="column" align="center">
              <img alt="InteGreat logo" src="../assets/qr-contact.jpg" />
              <p class="has-text-grey-dark is-size-6">
                <span class="has-text-weight-semibold">Line id:</span> @integreat
                <span class="th fw-100">
                  <span class="has-text-weight-normal">หรือติดต่อ</span> คุณ อังศุมาลิน พนมเกียรติศักดิ์(เปิ้ล)
                </span>
              </p>
              <p class="has-text-grey-dark is-size-6">
                <span class="th has-text-weight-normal">เบอร์โทรติดต่อ:</span> 06-1598-7893
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isOpenModalProfileMobile" :width="640" scroll="keep">
      <ProfileMobile v-if="getRule =='startup'" @actionModalChangEmail="actionModalChangEmail" />
      <ProfileStaffMobile v-if="getRule =='staff'" @actionModalChangEmail="actionModalChangEmail" />
      <ProfileAdminMobile v-if="getRule =='admin'" @actionModalChangEmail="actionModalChangEmail" />
    </b-modal>

    <b-modal :active.sync="isChangEmail" :width="640">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <div class="has-text-left">
              <b-field
                label="E-mail"
                class="width-max is-padding-sm-y icon-right-hidden"
                :message="
                ($v.emailChang.$error === true) ? 'กรุณากรอกอีเมลของคุณให้ถูกต้อง'
                :($v.emailChang.$error === false && emailNotUse === false)?'อีเมลนี้สามารถใช้งานได้'
                :($v.emailChang.$error === false && emailNotUse === true)?'อีเมลนี้ถูกใช้งานแล้ว'
                : ''"
                :type="($v.emailChang.$error === true) ? 'is-danger'
                :($v.emailChang.$error === false && emailNotUse === false)?'is-success'
                :($v.emailChang.$error === false && emailNotUse === true)?''
                : ''"
              >
                <b-input
                  type="text"
                  icon-pack="fas"
                  icon="pen"
                  @input="checkEmail()"
                  v-model="emailChang"
                  placeholder="กรุณากรอกอีเมลของคุณ"
                  expanded
                ></b-input>
              </b-field>

                <b-field
                label="Password"
                class="width-max is-padding-sm-y icon-right-hidden reveal"
              >
                <b-input
                  type="password"
                  password-reveal
                  icon-pack="mdi"
                  icon="lock"
                  @input="$v.passwordEmailChang.$touch()"
                  v-model="passwordEmailChang"
                  placeholder="กรุณากรอกรหัสผ่านของคุณ"
                  expanded
                ></b-input>
              </b-field>

            </div>
            <div class="is-flex is-flex is-align-end is-justify-end mg-t-10">
              <button
                @click="changEmail()"
                :disabled="($v.emailChang.$error === false && $v.passwordEmailChang.$error === false && emailNotUse === false)?false:true"
                class="button has-text-white is-background-primary mg-5"
                slot="trigger"
              >
                <span class="th">เปลี่ยน</span>
              </button>
              <button
                @click="actionModalChangEmail(false)"
                class="button has-text-grey-dark has-background-grey-lighter mg-5"
                slot="trigger"
              >
                <span class="th">ยกเลิก</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import profile from "@/components/Profile.vue";
import profileStaff from "@/components/ProfileStaff.vue";
import profileAdmin from "@/components/ProfileAdmin.vue";
import ProfileAdminMobile from "@/components/ProfileAdminMobile.vue";
import ProfileMobile from "@/components/ProfileMobile.vue";
import ProfileStaffMobile from "@/components/ProfileStaffMobile.vue";
import { HTTP } from "../axios.js";
import {
  required,
  minLength,
  sameAs,
  between,
  numeric,
  email,
  helpers
} from "vuelidate/lib/validators";

export default {
  validations: {
    emailChang: {
      required,
      email
    },
    passwordEmailChang: {
      required,
      minLength: minLength(8),
    },
  },
  name: "DashboardTemplate",
  components: {
    profile,
    profileStaff,
    profileAdmin,
    ProfileAdminMobile,
    ProfileMobile,
    ProfileStaffMobile
  },
  props: {
    title: String
  },
  data() {
    return {
      isBudget: "",
      search: "",
      widthMax: window.innerWidth,
      menuDashboard: "",
      menuStartup: "",
      selectedBudget: null,
      budget: ["2559", "2560", "2561", "2562", "2563", "2564", "2565"],
      menuStaff: "",
      allBatch: [],
      menuDoc: "",
      menuSignout: "",
      menuActivity: "",
      menuMilestone: "",
      menuForm: "",
      isSwitchBatch: false,
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      isOpenModalProfile: false,
      active: window.location.pathname,
      menuSpecialadmin: "",
      isUserTitle: false,
      navActive: false,
      isOpenModalProfileMobile: false,
      isContact: false,
      isChangEmail: false,
      emailChang: null,
      emailNotUse: null,
      dataSciencePark: [],
      passwordEmailChang:null
    };
  },
  watch: {
    user() {
      if (
        this.getRule !== "startup" &&
        (this.user.userStatus === 3 || this.user.statusActive === 3)
      ) {
         this.$buefy.dialog.alert(
          '<p class="has-text-centered is-size-5">ขณะนี้บัญชี inteGreat ของคุณถูกระงับการใช้งาน กรุณาติดต่อเจ้าหน้าที่</p>'
        );
        this.logout();
      }
    }
  },
  mounted() {
    this.getSciencePark();
    this.$store.commit("setModalActive", false);
    this.active = window.location.pathname;
    if (this.getRule === "startup") {
      this.setUserDetail();
    }
  },
  computed: {
    filteredDataBudget() {
      return this.budget.filter(
        option =>
          option
            .toString()
            .toLowerCase()
            .indexOf(this.isBudget.toLowerCase()) >= 0
      );
    },
    token() {
      return this.$store.state.token;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
    user() {
      return this.$store.getters.user;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    levelType() {
      return this.$store.state.levelType;
    },
    modalActive() {
      return this.$store.state.modalActive;
    },
    pageNavActivity() {
      return this.$store.state.pageNavActivity;
    },
    activeStartupStatus() {
      return this.$store.state.activeStartupStatus;
    }
  },
  methods: {
    getSciencePark() {
      HTTP.post("/get/all/science/park").then(res => {
        this.dataSciencePark = res.data.obj;
        // console.log('sadsad',res.data)
      });
    },
    getTiltleScience(data) {
      let dataSciencePark = this.dataSciencePark.filter(search => {
        return search._id == data;
      });
      // console.log('data',data)
      if (dataSciencePark.length > 0) {
        return dataSciencePark[0].name;
      }
    },
    actionModalChangEmail(status) {
      this.isChangEmail = status;
      this.emailChang = null;
      this.emailNotUse = null;
      this.passwordEmailChang = null
      this.$v.$reset();
    },
    checkEmail() {
      this.$v.emailChang.$touch();
      this.$v.passwordEmailChang.$touch()
      if (this.$v.emailChang.$invalid) {
      } else {
        const data = {
          email: this.emailChang
        };

        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        HTTP.post("api/user/check/email", data)
          .then(res => {
            // console.log("api/user/check/email", res);
            if (res.data.success) {
              this.emailNotUse = false;
            } else {
              this.emailNotUse = true;
            }
          })
          .catch(e => {
            console.log("api/user/check/email/error", e);
          });
      }
    },
    changEmail() {
      let data = {
        email: this.emailChang,
        password:this.passwordEmailChang
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("api/change/email", data)
        .then(res => {
          // console.log("api/change/email/res", res);
          if (res.data.success) {
             this.$buefy.dialog.alert({
              message:
                '<p class="has-text-centered is-size-5">เปลี่ยนอีเมลเรียบร้อยแล้วกรุณาตรวจสอบอีเมลของคุณเพื่อทำการยืนยันตัวตน และทำการเข้าสู่ระบบใหม่อีกครั้ง</p>',
              onConfirm: () => this.logout()
            });
          } else {
             this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch(e => {
          console.log("api/change/email/error", e);
           this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    everEmailActive() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("api/ever/send/email/actived")
        .then(res => {
          //  console.log("api/ever/send/email/actived/", res);
          if (res.data.success) {
             this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบได้ทำการส่งอีเมลยืนยันตัวตนเรียบร้อยแล้ว กรุณาตรวจสอบอีเมลของคุณ</p>'
            );
          } else {
             this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch(e => {
          console.log("api/document/delete/file/error", e);
           this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    alertDailog() {
       this.$buefy.dialog.alert(
        '<p class="has-text-centered is-size-5">คุณถูกระงับการเข้าใช้งานโครงการ กรุณาติดต่อผู้ดูแล</p>'
      );
    },
    logout() {
      this.$router.push("/signin");
      this.$store.dispatch("logout").then(() => {
        setTimeout(() => {
          window.localStorage.clear();
        }, 100);
        this.$store.commit("resetState");
        window.localStorage.removeItem("vuex");
        delete HTTP.defaults.headers.common.Authorization;
      });
    },
    openModalProfile() {
      this.isOpenModalProfile = true;
    },
    closeModalProfile() {
      this.isOpenModalProfile = false;
    },
    getUserDetailName() {
      let title = "";
      if (typeof this.user.titleName !== "undefined") {
        title = this.user.titleName;
      } else {
        title = "";
      }

      name = `${title} ${this.user.name} ` + ` ${this.user.surname}`;

      return name;
    },
    getUserImage() {
      let img = "";
      if (
        this.getRule === "admin" ||
        this.getRule === "startup" ||
        this.getRule === "board" ||
        this.getRule === "exclusiveboard"
      ) {
        img = this.user.organizeLogo;
      } else {
        img = this.user.profilePic;
      }
      return img;
    }
  }
};
</script>
<style>
@media screen and (min-width: 320px) {
  #notData {
    margin-top: 0rem;
  }
}
@media screen and (min-width: 768px) {
  #notData {
    margin-top: 10rem;
  }
}
@media screen and (min-width: 1281px) {
  #notData {
    margin-top: 10rem;
  }
}
@media screen and (min-width: 1408px) {
  #notData {
    margin-top: 10rem;
  }
}
.boxBatchMain {
  height: 15rem !important;
  border: 1px solid #d8d8d8;
  display: flex !important;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 1rem;
}
@media only screen and (max-width: 768px) {
  .boxBatch {
    width: 17rem;
    height: 14rem !important;
    border: 1px solid #d8d8d8;
    display: flex !important;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 1rem 0rem 1rem 0rem;
  }
  .card.border-inside.modal-batch > .card-content {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
@media only screen and (min-width: 768px) {
  .boxBatch {
    width: 20rem;
    height: 14rem !important;
    border: 1px solid #d8d8d8;
    display: flex !important;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 1rem 1rem 1rem 1rem;
  }
  .card.border-inside.modal-batch > .card-content {
    padding: 24px;
  }
  .modal-min-width > .animation-content.modal-content {
    min-width: 0px !important;
  }
}
@media screen and (min-width: 1281px) {
  .modal-min-width > .animation-content.modal-content {
    min-width: 1350px !important;
  }
}
/* .dashboard .columns {
  min-height: 100vh;
  margin-left: 0;
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
} */
.dashboard .columns .column.main-d {
  z-index: 10;
  width: 90%;
}
.dashboard aside {
  width: 125px;
  display: flex;
  flex-direction: column;
  z-index: 20;
}
.dashboard aside.menu .link p {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  margin-bottom: 1.5rem;
}
.dashboard aside.menu .link:hover p {
  font-weight: 500;
}
.dashboard aside.menu .link:nth-last-child(2) {
  margin-bottom: auto;
}
.dashboard aside img.is-padding-x {
  padding-left: 2.2rem !important;
  padding-right: 2.2rem !important;
}
.dashboard .dropdown .dropdown-menu .has-link a {
  padding: 0.8rem 0px;
}
hr {
  background-color: #d8d8d8 !important;
  border: none;
  display: block;
  height: 1px !important;
  margin: 1.5rem 0;
}
.dashboard .icon.is-large {
  cursor: pointer;
}
.boxWelcome {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: row;
  margin-top: 0.9rem;
}
.textWelcome {
  margin-right: 0.5rem !important;
}
.btnSearch {
  background-color: #0ecb81 !important;
  color: #fff !important;
  width: 100% !important;
}
.btnReset {
  background-color: #dbdbdb !important;
  color: #000000 !important;
  width: 100% !important;
}
.headerFilter {
  padding-bottom: 1rem !important;
  flex: 1;
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
}

.boxBatch:focus {
  border: 2px solid #00a79d !important;
}
.widthBoxBatch {
  width: 17rem !important;
}
.nav-mobile {
  background-color: #00a79d;
  min-height: 60px;
  padding: 10px;
}
.box-circle-mobile {
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
}
#slide {
  position: absolute;
  left: -200px;
  min-height: 100%;
  transition: all 0.5s ease-in-out;
}
.wrapper {
  position: relative;
  overflow: hidden;
}
.slide-active {
  transition: all 0.5s ease-in-out;
  left: 0 !important;
}
.card.m-h-switbatch {
  min-height: 535px;
}
.footer-db,
.partner-logo img {
  opacity: 0.6;
  transition: opacity 0.5s ease;
}
.footer-db:hover,
.partner-logo img:hover {
  opacity: 1;
}

.is-background-secondary {
  background-color: #6d8df3;
}

.menu.is-background-secondary img {
  -webkit-filter: hue-rotate(70deg);
  filter: hue-rotate(70deg);
}
.m-h-switbatch .dropdown-menu {
  width: auto;
}
.icon-right-hidden .control .icon.is-right.has-text-danger {
  display: none !important;
}
.active-email-boder {
  border: 1px solid #ac1818;
  border-radius: 5px;
  margin: 11px 0;
}
</style>
